// extracted by mini-css-extract-plugin
export var colorSquare = "_nk-0";
export var danger = "_nk-5";
export var lightPink = "_nk-8";
export var neutralBlue = "_nk-7";
export var neutralYellow = "_nk-6";
export var normal = "_nk-1";
export var primary = "_nk-2";
export var primaryLight = "_nk-3";
export var solidBlack = "_nk-g";
export var solidGreen = "_nk-b";
export var solidLightBlue = "_nk-d";
export var solidNavy = "_nk-c";
export var solidOrange = "_nk-f";
export var solidPink = "_nk-e";
export var solidRed = "_nk-9";
export var solidYellow = "_nk-a";
export var success = "_nk-4";